/*
  AUMAERK – Anrede-Auswahl im Warenkorb.

  - Speichert die Wahl sofort als Cart-Attribut "Anrede" (/cart/update.js),
    damit sie Re-Renders des Warenkorbs übersteht und auch beim direkten
    Sprung auf /checkout (Drawer) mitkommt.
  - Hält alle Instanzen (Drawer + Warenkorb-Seite) synchron.
  - Pflichtauswahl: Ein Klick auf "Zur Kasse" wird abgefangen, solange nichts
    gewählt ist. Der Listener läuft in der Capture-Phase auf document und
    damit vor den Checkout-Guards des Themes (component-cart.js).
*/
(function () {
  'use strict';

  if (window.AumaerkAnrede) return;

  var ATTR = 'Anrede';
  var VALID = ['Herr', 'Frau', 'keine Angabe'];
  var MESSAGE = 'Bitte wähle, wie wir dich ansprechen dürfen.';

  var current = null;
  var pending = null;

  function isValid(value) {
    return VALID.indexOf(value) !== -1;
  }

  function roots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-cart-anrede]'));
  }

  function updateUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'cart/update.js';
  }

  function clearFeedback(root) {
    var fb = root.querySelector('[data-cart-anrede-feedback]');
    if (fb) {
      fb.textContent = '';
      fb.setAttribute('hidden', '');
    }
    root.classList.remove('cart__anrede--invalid');
  }

  function showFeedback(root) {
    if (!root) return;
    var fb = root.querySelector('[data-cart-anrede-feedback]');
    if (fb) {
      fb.textContent = MESSAGE;
      fb.removeAttribute('hidden');
    }
    root.classList.add('cart__anrede--invalid');
  }

  function scrollToRoot(root) {
    if (!root) return;
    var drawerBody = root.closest('.sidebar__body');
    if (drawerBody) {
      var targetTop = drawerBody.scrollTop
        + root.getBoundingClientRect().top
        - drawerBody.getBoundingClientRect().top
        - 16;
      drawerBody.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
    } else if (typeof root.scrollIntoView === 'function') {
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  // Bring every instance (incl. freshly re-rendered ones) in line with the
  // latest known choice.
  function applyState() {
    roots().forEach(function (root) {
      root.setAttribute('data-cart-anrede-synced', 'true');
      if (current === null) return;
      root.querySelectorAll('[data-cart-anrede-option]').forEach(function (radio) {
        radio.checked = radio.value === current;
      });
      var hidden = root.querySelector('[data-cart-anrede-hidden]');
      if (hidden) hidden.value = current;
      if (isValid(current)) clearFeedback(root);
    });
  }

  function readInitial() {
    var checked = document.querySelector('[data-cart-anrede] [data-cart-anrede-option]:checked');
    if (checked && isValid(checked.value)) current = checked.value;
  }

  function save(value) {
    if (!isValid(value)) return;
    current = value;
    applyState();

    var body = { attributes: {} };
    body.attributes[ATTR] = value;

    var request = fetch(updateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .catch(function (err) { console.warn('AumaerkAnrede: Speichern fehlgeschlagen', err); })
      .then(function () {
        if (pending === request) pending = null;
      });

    pending = request;
  }

  function rootForButton(btn) {
    var sidebar = btn.closest('#site-cart-sidebar');
    if (sidebar) {
      var inDrawer = sidebar.querySelector('[data-cart-anrede]');
      if (inDrawer) return inDrawer;
    }
    return document.querySelector('[data-cart-anrede][data-cart-anrede-instance="page"]')
      || document.querySelector('[data-cart-anrede]');
  }

  // ---- events -------------------------------------------------------------

  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || !target.matches || !target.matches('[data-cart-anrede-option]')) return;
    if (target.checked) save(target.value);
  });

  document.addEventListener('click', function (e) {
    if (!e.target || typeof e.target.closest !== 'function') return;
    var btn = e.target.closest('#CheckOut, button[name="checkout"], input[name="checkout"]');
    if (!btn || btn.disabled) return;

    // No Anrede field rendered (e.g. other template) → don't interfere.
    var root = rootForButton(btn);
    if (!root) return;

    if (isValid(current)) {
      // Choice made but still saving → wait, then click again.
      if (pending) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var btnId = btn.id;
        pending.then(function () {
          var again = btn.isConnected ? btn : (btnId ? document.getElementById(btnId) : null);
          if (again) again.click();
        });
      }
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
    showFeedback(root);
    scrollToRoot(root);
  }, true);

  // Cart fragments get swapped via innerHTML (qty changes, discounts, …).
  // Re-apply the current choice to any new, not yet synced instance.
  function syncNewRoots() {
    var unsynced = document.querySelector('[data-cart-anrede]:not([data-cart-anrede-synced])');
    if (unsynced) applyState();
  }

  function init() {
    readInitial();
    applyState();
    if (typeof MutationObserver === 'function' && document.body) {
      new MutationObserver(syncNewRoots).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.AumaerkAnrede = {
    get value() { return current; },
    isValid: function () { return isValid(current); }
  };
})();
